<template>
	<div class="card">
		<div class="card-body">
			
		<div v-if="done">
			<b-container fluid>
				<b-form @submit="onSubmit">
					<input type="hidden" id="dataItem-id-hidden" v-model="dataItem.id" />
<b-form-group label="Name">
      <b-form-input
          type="text"
          id="dataItem-name-input"
          class="form-input"
          v-model="dataItem.name"
          @blur="$v.dataItem.name.$touch()"
      ></b-form-input>
      <div class="invalid-feedback">
          <div v-if="!$v.dataItem.name.required">Name is required</div>
      </div>
      </b-form-group>
			<b-form-group label="Tracking URL"> 
      <b-form-input
          type="text"
          id="dataItem-trackingUrl-input"
          class="form-input"
          v-model="dataItem.trackingUrl"
      ></b-form-input>
      </b-form-group>
<!-- <b-form-group label="Active">
  <b-form-checkbox
    id="dataItem-active-input"
    class="form-input"
    v-model="dataItem.active">Active
    </b-form-checkbox>
  </b-form-group> -->

					<b-button
						type="submit"
						variant="primary"
						style="margin: 5px;"
					>Save</b-button>
					<b-button
						style="margin: 5px;"
						@click="cancel"
					>Cancel</b-button>
				</b-form>
			</b-container>
		</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import service from '../../service';
import { ShippingProviderDto } from '../../dto';

export default {
	name: 'edit',
	data: () => ({
		done: false,
		dataItem: null
  	}),
	computed: {
		id() {
			return this.$route.params.id;
		}
	},
	methods: {
		async onSubmit(e) {
			e.preventDefault();

			this.$v.dataItem.$touch();
			if (this.$v.dataItem.$invalid) {
				return;
			}

			// let payload = new ShippingProviderDto(this.dataItem);

			try {
				const id = await service.updateShippingProvider(this.dataItem);
				this.redirectToListing();
			} catch {}
		},
		cancel(){
			this.redirectToListing();
		},
			redirectToListing() {
			this.$router.push({ name: 'ShippingProviders' });
		}
	},
	mounted() {
		this.done=false;
    this.setContainerLoader(true);
    service.getShippingProviderById(this.id).then((data) => {
      this.setContainerLoader(false);
      this.dataItem = data;
      this.done = true;
    }).catch(() => {
      this.setContainerLoader(false);
      //return back to listing page because error in fetch record
      this.$router.push({name: 'ShippingProviders'});
    });
	},
	validations:{
		dataItem:{

      id:{
      },
      name:{
      },
      createdByUserId:{
      },
      modifiedByUserId:{
      },
      dateCreated:{
      },
      dateModified:{
      },
      active:{
      },
		}
	}
}
</script>
